import { ref, computed, readonly, onMounted, onUnmounted } from 'vue'

export interface DeviceInfo {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isIOS: boolean
  isAndroid: boolean
  screenWidth: number
  screenHeight: number
  hasTouch: boolean
}

export function useDevice() {
  const device = ref<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isIOS: false,
    isAndroid: false,
    screenWidth: 0,
    screenHeight: 0,
    hasTouch: false,
  })

  const updateDevice = () => {
    if (typeof window === 'undefined') return

    const width = window.innerWidth
    const height = window.innerHeight
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera

    // 檢測設備類型
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream
    const isAndroid = /android/i.test(userAgent)
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    device.value = {
      isMobile: width < 768,
      isTablet: width >= 768 && width < 1024,
      isDesktop: width >= 1024,
      isIOS,
      isAndroid,
      screenWidth: width,
      screenHeight: height,
      hasTouch,
    }
  }

  onMounted(() => {
    updateDevice()
    window.addEventListener('resize', updateDevice)
    window.addEventListener('orientationchange', updateDevice)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateDevice)
    window.removeEventListener('orientationchange', updateDevice)
  })

  return {
    device: readonly(device),
    isMobile: computed(() => device.value.isMobile),
    isTablet: computed(() => device.value.isTablet),
    isDesktop: computed(() => device.value.isDesktop),
    isIOS: computed(() => device.value.isIOS),
    isAndroid: computed(() => device.value.isAndroid),
    hasTouch: computed(() => device.value.hasTouch),
    screenWidth: computed(() => device.value.screenWidth),
    screenHeight: computed(() => device.value.screenHeight),
  }
}

